import { render, staticRenderFns } from "./IntegrationForm.vue?vue&type=template&id=316f5025&scoped=true"
import script from "./IntegrationForm.vue?vue&type=script&lang=js"
export * from "./IntegrationForm.vue?vue&type=script&lang=js"
import style0 from "./IntegrationForm.vue?vue&type=style&index=0&id=316f5025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316f5025",
  null
  
)

export default component.exports